export const getSliceLabel = ({ start, end }) => `${start} - ${end}`;
